import React, { Fragment, useState, useEffect } from 'react';
import { Dialog, Transition } from '@headlessui/react';
import { CheckIcon, PlusCircleIcon } from '@heroicons/react/outline';
import { Link } from 'react-router-dom';
import PreOnboardServices from '../services/PreObnoard';
import fire from '../utils/Toastr';
import Modal from './Modals/preonboard/modal';

const FileUploadAndDownloadComponent = ({details}) => {
  const [uploadProgress, setUploadProgress] = useState(0);
  const [uploadStatus, setUploadStatus] = useState('Upload user');
  const [fileName, setFileName] = useState('');
  const [file, setFile] = useState(null);
  const [adminType, setAdminType] = useState("");
  const [open, setOpen] = useState(false);
  const [loading, setLoading] = useState(false);
  const [isSubmit, setSubmitted] = useState(false)
  const [isApproved, setIsApproved] = useState(localStorage.getItem("isApproved"))

  useEffect(() => {
    const userDetail = sessionStorage.getItem("user");
    const userDetails = JSON.parse(userDetail);
    setAdminType(userDetails.adminType);
  }, []);

  const simulateUpload = async (file) => {
    setUploadStatus('Uploading...');
    let progress = 0;

    const interval = setInterval(async () => {
      progress += 10;
      setUploadProgress(progress);

      if (progress >= 100) {
        clearInterval(interval);
        setUploadStatus('Uploaded');
        setFileName(file.name);
        setFile(file);
      }
    }, 100); // Simulate upload progress
  };

  const handleSubmitFile = async () => {
    const formData = new FormData();
    formData.append('file', file)
     try {
      setLoading(true)
      const response = await  PreOnboardServices.acceptUploads(formData);
        if(response){
          fire("success", "File uploaded, waiting for checker approval")
        }
        setLoading(false)
        setSubmitted(true)
     } catch (error) {
      console.log(error);
      setLoading(false)
     }
  }
  const uploadUser = (event) => {
    const file = event.target.files[0];

    if (file) {
      simulateUpload(file);

    } else {
      alert('Please upload a valid Excel file');
    }
  };

  //test your code

  useEffect(() => {
     checkApprovalStatus()
  }, [isApproved, isSubmit])
 
  const checkApprovalStatus = () => {
      const getApprovalStatus = localStorage.getItem("isApproved")
      setIsApproved(getApprovalStatus);
  }

  const handleApproveUploadedUser = async () => {
    try {
      setLoading(true)
      const response = await PreOnboardServices.approveUploads();
      if(response){
        localStorage.setItem("isApproved", "true");
        fire("success", "Uploaded users approved");
        setLoading(false)
        setOpen(false);
        setTimeout(() => {
          window.location.reload();
        }, 2000);
      }
    } catch (error) {
      console.log(error);
      setOpen(false);
    }
  };

  return (
    <div>
      {adminType.toLowerCase() === "maker" && (
        <div className='flex items-start'>
          <Link to="/create/preonboard" className="">
                        <button
                          type="button"
                          className="inline-flex items-center justify-center rounded-md border border-transparent btn-primary px-2 py-2 text-sm font-medium text-white shadow-sm  sm:w-auto"
                        >
                          <PlusCircleIcon className="w-4 mr-1.5" />
                            PreOnboard user
                        </button>
          </Link>
          <div>
          <button
            type="button"
            className="inline-flex items-center z-50 justify-center rounded-md border border-transparent btn-primary px-2 py-2 text-sm font-medium text-white shadow-sm sm:w-auto ml-10 gap-5"
          >
            <label>
              <p>{uploadStatus}</p>
              <input
                type="file"
                accept=".csv"
                className="hidden"
                onChange={uploadUser}
              />
            </label>
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" className="w-5">
              <path fillRule="evenodd" d="M11.47 2.47a.75.75 0 0 1 1.06 0l4.5 4.5a.75.75 0 0 1-1.06 1.06l-3.22-3.22V16.5a.75.75 0 0 1-1.5 0V4.81L8.03 8.03a.75.75 0 0 1-1.06-1.06l4.5-4.5ZM3 15.75a.75.75 0 0 1 .75.75v2.25a1.5 1.5 0 0 0 1.5 1.5h13.5a1.5 1.5 0 0 0 1.5-1.5V16.5a.75.75 0 0 1 1.5 0v2.25a3 3 0 0 1-3 3H5.25a3 3 0 0 1-3-3V16.5a.75.75 0 0 1 .75-.75Z" clipRule="evenodd" />
            </svg>
          </button>

          {uploadProgress > 0 && uploadProgress < 100 && (
            <div className="w-full bg-gray-200 rounded-full h-2.5 dark:bg-gray-700 mt-2">
              <div className="bg-blue-600 h-2.5 rounded-full" style={{ width: `${uploadProgress}%` }}></div>
            </div>
          )}

          {fileName && !isSubmit &&  (
            <div className="mt-2 flex flex-col gap-1">
              <p className="text-sm text-gray-700 ml-11">{fileName}</p>
              
                <button  className="inline-flex items-center z-50 justify-center rounded-md border border-transparent btn-primary px-2 py-2 text-sm font-medium text-white shadow-sm sm:w-auto mt-2 ml-2" type="button" onClick={handleSubmitFile}>{loading ? "Submitting..." : "Submit"}</button>
              
            </div>
          )}
          </div>
        </div>
      )}

      {adminType.toLowerCase() === "checker" && (!isApproved || isApproved?.toLowerCase() != "true") && (
        <div>
          <button
            type="button"
            onClick={() => setOpen(true)}
            className="inline-flex items-center z-50 justify-center rounded-md border border-transparent btn-primary px-2 py-2 text-sm font-medium text-white shadow-sm sm:w-auto mt-2 ml-2"
          >
            Approve Bulk upload
          </button>
          <div className='absolute '>
          <Modal textField="to approve these users" action={handleApproveUploadedUser} open={open} setOpen={setOpen} loading={loading} />
          </div>
        </div>
      )}
    </div>
  );
};

export default FileUploadAndDownloadComponent;
